'use client';

import styles from './Footer.module.scss';

const Footer = () => {
	// production 도메인(stepin.ai)에서만 숨김
	// 로컬 개발 & dev 웹사이트에서는 버전 정보 표시

	// 실제 접속한 URL의 hostname 체크
	const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

	// stepin.ai 도메인이면 숨김
	if (hostname.includes('stepin.ai')) {
		return null;
	}

	const commitHash = process.env.NEXT_PUBLIC_GIT_COMMIT_HASH || 'unknown';
	const branch = process.env.NEXT_PUBLIC_GIT_BRANCH || 'unknown';
	const buildTime = process.env.NEXT_PUBLIC_BUILD_TIME || 'unknown';

	const formattedBuildTime =
		buildTime !== 'unknown'
			? new Date(buildTime).toLocaleString('ko-KR', {
					year: 'numeric',
					month: '2-digit',
					day: '2-digit',
					hour: '2-digit',
					minute: '2-digit',
				})
			: 'unknown';

	return (
		<footer className={styles.footer}>
			<div className={styles.container}>
				<div className={styles.info}>
					<span className={styles.commit}>{commitHash}</span>
					<span className={styles.separator}>•</span>
					<span className={styles.branch}>{branch}</span>
					<span className={styles.separator}>•</span>
					<span className={styles.buildTime}>{formattedBuildTime}</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
